"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processOptions = void 0;
const util_1 = require("@app/util");
const processOptions = (opts) => opts.map((opt) => ({
    ...opt,
    label: (0, util_1.t)(opt.label),
}));
exports.processOptions = processOptions;
